import { Variant } from "../../../types/types";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import styles from "./GalleryTeaser.module.scss";

export interface GalleryTeaserUIProps {
  selectedVariant: Variant;
  galleryElementId: string;
}

export const ImageHeight = 320;
export const ImageWidth = 240;

export const GalleryTeaserUI = ({
  galleryElementId,
  selectedVariant,
}: GalleryTeaserUIProps) => {
  const hasMultipleImages = !!selectedVariant.images.alternatives.length;
  const handleViewImagesButtonClick = () =>
    document
      .getElementById(galleryElementId)
      ?.scrollIntoView({ behavior: "smooth" });

  return (
    <div data-testid="gallery-teaser" className={styles.wrapper}>
      <button
        type="button"
        className={styles.mainImageButton}
        onClick={handleViewImagesButtonClick}
        aria-label="main product image"
        data-testid="gallery-teaser:main-image:button"
      >
        <img
          src={`${selectedVariant.images.primary}?wid=${ImageWidth}&hei=${ImageHeight}`}
          alt={selectedVariant.title}
          className={styles.mainImage}
        />
      </button>
      <UnderlinedButton
        onClick={handleViewImagesButtonClick}
        className={styles.viewMore}
      >
        {hasMultipleImages ? "View images" : "View image"}
      </UnderlinedButton>
    </div>
  );
};
